import React from "react";

import HomeCards from "./HomeCards/HomeCards";
import NewsCards from "./NewsCards/NewsCards";

const CardsContainer = ({ articles, activeArticle }) => {
  const renderCards = (articles) =>
    !articles.length ? (
      <HomeCards />
    ) : (
      <NewsCards articles={articles} activeArticle={activeArticle} />
    );

  return renderCards(articles);
};

export default CardsContainer;
